import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

if(localStorage.getItem('token'))
  axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem('token')

//const url = 'http://10.1.0.72:8080'
/* const url = 'http://localhost:8080' */
const url = ''

function isRecent(timestamp, range){
  let now = new Date()
  const last_timestamp = new Date(timestamp)
  const previous_minute = now.setMinutes((last_timestamp.getMinutes()-1))
  const time_diff = (previous_minute.valueOf() - last_timestamp.valueOf())
  if ( time_diff < (range * 60 * 1000) ) return true 
  else return false
}

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user')) || {},
    producers: [],
    data_loading: false,
    timezone: "Atlantic/Madeira",
    data: [],
    data_total_group: [],
    current_data: {},
    selection: {
      range: null,
      producerId: null,
      groupId: null
    },
    ev_colors: ["rgb(3, 166, 120)", "rgb(134, 226, 213)", "rgb(30, 130, 76)", "rgb(135, 211, 124)", "rgb(0, 230, 64)", 
    "rgb(145, 180, 150)"],
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, data){
      state.status = 'success'
      state.token = data.token
      state.user = data.user
    },
    auth_error(state){
      state.status = 'error'
    },
    data_loading(state, status){
      state.data_loading = status
    },
    get_producers(state, producers){
      state.producers = producers
    },
    clear_data(state){
      state.data = []
      state.data_total_group = []
      //state.current_data = {}
      //state.data_appliances = []
    },
    clear_current_data(state){
      state.current_data = {}
    },
    store_data(state, data){
      state.data = data
    },
    store_data_total_group(state, data){
      state.data_total_group = data
    },
    store_current_data(state, data){
      state.current_data = data
    },
    set_range(state, range){
      state.selection.range = range
    },
    set_producerId(state, producerId){
      state.selection.producerId = producerId
    },
    set_groupId(state, groupId){
     state.selection.groupId = groupId
    },
    clear_selection(state){
      state.selection.producerId = null
      state.selection.range = null
      state.selection.groupId = null
    },
    logout(state){
      state.status = ''
      state.token = ''
    }
  },
  actions: {
    login({commit}, user_credentials){
        return new Promise((resolve, reject) => {
          commit('auth_request')
          axios.post(`${url}/api/login`, user_credentials)
          .then(response => {
            const token = response.data.jwt
            const user = response.data.user
            localStorage.setItem('token', token)
            localStorage.setItem('user', JSON.stringify(user))
            axios.defaults.headers.common['Authorization'] = 'Bearer '+token
            commit('auth_success', { token, user })
            resolve(response.data)
          })
          .catch(err => {
            commit('auth_error')
            localStorage.removeItem('token')
            reject(err)
          })
        })
    },
    logout({commit}){
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    },
    changePassword({commit}, data){
      return new Promise((resolve,reject) => {
        axios.post(`/api/changePassword`, data).then(response => {
          if(response) resolve()
        })
        .catch(err => {
          reject(err.response.data.error)
        })
      })
    },
    exportCSV({commit}, { sourceId, deviceId, export_start, export_end }) {
      return new Promise((resolve, reject) => {
        axios.get(`/admin/exportcsv/${sourceId}/${deviceId}?start=${export_start.toJSON()}&end=${export_end.toJSON()}`, {responseType: 'blob'}).then(response => {
          //console.log(response.data)
          return resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    getWeather({commit}){
      return new Promise((resolve, reject) => {
        const user_location = this.state.user.local.id
        axios.get(`/api/ipma/${user_location}`, {}, {headers:{'Authorization': ''}})
        .then(response => {
            const today = moment(new Date()).format('YYYY-MM-DDTHH:00:00')
            const weather_now = response.data.filter(r => {
                return r.dataPrev == today
            })
            resolve(weather_now[0])
        })
        .catch(err => {
            reject(err)
        })
      })
    },
    getProducers({commit}){
      return new Promise((resolve, reject) => {
        axios.get(`/api/producers`).then(response => {
          commit('get_producers', response.data)
          resolve()
        }).catch(err => { console.log(err); reject(err) })
      })
    },
    getCurrentData({commit}, { query, batteries=[] }){
      return new Promise(async (resolve, reject) => {
        //console.log("Requesting current data", JSON.stringify(query))
        const result = await this.dispatch('request_single_data', { 
          ...query, 
          range:'hour', 
          batteries, 
          multi_request: true,
          loading: false
        }).then(response => response)
        
        if (!result.hasOwnProperty("data") || !result.data.summaryChart.length) {
          commit('store_current_data', {})
          return resolve()
        }

        let last = result.data.summaryChart.slice(-1)[0]
        if (last.hasOwnProperty('PV') && last.PV != null) last.production = Math.round(last.PV)
        if (last.hasOwnProperty('House') && last.House != null) last.consumption = Math.round(last.House) 
       
        last.batteries = result.batteries.map(battery => {

          const battery_level = battery.summaryChart.length ? battery.summaryChart.slice(-1)[0].battery_capacity : null
          let last_setpoints = battery.samples.filter(s => s.hasOwnProperty("bess_manager_api_response_ok") && s.hasOwnProperty("bess_manager_setpoints")) || null
          let setpoints = null
          if (last_setpoints.length) {
            setpoints = last_setpoints.slice(-3)
            setpoints = setpoints.map(s => JSON.parse(s.bess_manager_setpoints))
          }

          //console.log("LAST SAMPLE", battery.last_sample)
          return { 
            battery_level: battery_level != null ? Math.round(battery_level) : null,
            name: battery.name,
            last_setpoints: setpoints,
            device: battery.device,
            current_setpoint: battery.current_setpoint,
            last_sample: battery.last_sample.length ? battery.last_sample.slice(-1)[0] : null, //battery.samples.length ? battery.samples.slice(-1)[0] : null,
            battery: battery.summaryChart.length ? battery.summaryChart.slice(-1)[0].battery : null,
          }
        })
      
        if (last.hasOwnProperty('PV_Grid') && last.PV_Grid != null) last.wasting = Math.round(last.PV_Grid) 

        commit('store_current_data', last) 
        return resolve()
      })
    },
    request_data({commit}, {range, producerId, groupId, datetime}){
      commit('data_loading', true)
      return new Promise((resolve, reject) => {
        let query = {}
        query.producerId = producerId
        query.groupId = groupId
        query.datetime = datetime
        if (range == 'day') query.interval = 1
        axios.get(`/api/producer/average/${range}`, { params: query }).then(response => {
          commit('data_loading', false)
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    request_single_data({commit}, { range, producerId, groupId, datetime, loading=true, batteries=[], samples=false, has_forecast=false, recursive=false, multi_request=false }) {
      return new Promise(async (resolve, reject) => {
        let query = { producerId, groupId, datetime }
        //console.log("data_loading", loading)
        if (loading) commit('data_loading', true)
        let promises = []
        
        // NOVO
        let producer = null
        if (this.getters.user_isAdmin) producer = this.state.producers.find(p => p.id == producerId || p._id == producerId) 
        else producer = this.state.user 

        let is_total_group = false
        const group = producer.groups.find(g => g.id == groupId || g._id == groupId) || {}
        if (group.name && group.name == "Total") is_total_group = true

        let next_hours = false
        if (range == 'next_hours') {
          range = 'day'
          query.datetime = new Date().toJSON()
          next_hours = true
        }
        if (range == 'day') query.interval = 1
        if (range == 'day' && samples) query.interval = 5
        if (range == 'week') query.interval = 30
        if (range == 'month') query.interval = 60

        
        if (!producer.contract.phases || producer.contract.phases == 1) {
          promises.push(axios.get(`/api/producer/group/${query.groupId}/average/${range}`, { params: query }))
        } else {
          const phases = ["L1", "L2", "L3"]
          for (let p of phases) {
            promises.push(axios.get(`/api/producer/group/${query.groupId}/average/${range}`, { params: {...query, phase: p} }))
          }
        }
        // FIM NOVO

        // FORECASTS
        let forecast_result = []
        if (this.getters.user_isAdmin) {
          let forecasts = this.getters.group_forecasts
          let forecast_promises = []
          forecasts.forEach(f => {
            forecast_promises.push(axios.get(`/api/producer/device/${f.deviceId}/average/${range}`, { params: query }).then(response => {
              return { 
                response, 
                device: f,
              } 
            }).catch(e => reject(e)))
          })

          forecast_result = await Promise.all(forecast_promises).then(result => result)
        }

        // SAMPLES
        if (samples) {
          var samples_result = []
          let samples_promises = []
          group.devicesIds.forEach(deviceId => {
            const device = producer.devices.find(d => d.deviceId == deviceId)
            if (device && device.hasOwnProperty("type") && (device.type == "consumption" || device.type == "grid")) {
              samples_promises.push(axios.get(`/api/device/${device.deviceId}/samples/average/${range}`, { params: query }).then(response => {
                return {
                  data: response.data,
                  device: device
                }
              }).catch(e => reject(e)))
          }})
          samples_result = await Promise.all(samples_promises).then(result => result)
        }


        // BATTERIES
        batteries.forEach(b => {
          const deviceId = b.deviceId
          const deviceName = b.name
          let batt = producer.devices.find(d => d.deviceId == deviceId) || null
          const xoltaId = batt.xolta ? batt.xolta.id : null
          promises.push(new Promise((resolve, reject) => {
            Promise.all([
              axios.get(`/api/producer/device/${deviceId}/average/${range}`, { params: query }).then(response => response),
              axios.get(`/api/device/${deviceId}/samples/average/${range}`, { params: query }).then(response => response.data),
              axios.get(`/api/producer/battery/${deviceId}/setpoints`).then(current_setpoint => current_setpoint.data),
              axios.get(`/api/producer/`, { params: query }).then(producer => producer.data),
              axios.get(`/api/device/${deviceId}/samples/hour/`, { params: { producerId } }).then(response => response.data)
            ]).then(result => {
              const batt = result[3].devices.find(d => d.deviceId == deviceId) || null 
              return resolve({
                response: result[0],
                b: { ...batt, name: deviceName },
                samples: result[1],
                current_setpoint: result[2],
                last_sample: result[4]
              })
            }).catch(e => reject(e))
          }))
        })

        Promise.all(promises).then(async result => {
          //if (!result[0].data.summaryChart.length && !next_hours) {
          if (!next_hours) {
            if ((!producer.contract.phases || producer.contract.phases == 1) && !result[0].data.summaryChart.length ) {
              commit('store_current_data', []) 
              commit('data_loading', false)
              return resolve({})
            }
          }

          let output = {}
          if (!producer.contract.phases || producer.contract.phases == 1) {
            output.data = result[0].data 
          } else {
            output.data = {}
            output.data.energyUsed = result[0].data.energyUsed

            // Summary Chart Sum
            const datetimeSummaryChart = {}
            for (let phase of [0,1,2]) {
                for (let sample of result[phase].data.summaryChart) {
                    if (!datetimeSummaryChart.hasOwnProperty(sample.datetime)) {
                        datetimeSummaryChart[sample.datetime] = sample
                    } else {
                        for (let p in sample) {
                            if (p == "datetime") continue
                            datetimeSummaryChart[sample.datetime][p] += sample[p] ? sample[p] : 0
                        }
                    }
                }
            }
            output.data.summaryChart = Object.values(datetimeSummaryChart).sort((a,b) => (new Date(a.datetime)).valueOf() - (new Date(b.datetime)).valueOf())
            //console.log("SUMMARY CHART", output.data.summaryChart)

            // Energy Used SUM L1 L2 L3
            for (let p in result[0].data.energyUsed) {
              output.data.energyUsed[p] += result[1].data.energyUsed[p] + result[2].data.energyUsed[p]
            }

            // Daily Energy Used SUM L1 L2 L3
            if (range == 'week') {
              output.data.dailyEnergyUsed = result[0].data.dailyEnergyUsed
              for (let s=0; s < result[0].data.dailyEnergyUsed.length; s++) {
                for (let p in result[0].data.dailyEnergyUsed[s]) {
                  if (p == "datetime") continue
                  const L2_p_value = result[1].data.dailyEnergyUsed.length ? (result[1].data.dailyEnergyUsed[s] ? result[1].data.dailyEnergyUsed[s][p] : 0) : 0
                  const L3_p_value = result[2].data.dailyEnergyUsed.length ? (result[2].data.dailyEnergyUsed[s] ? result[2].data.dailyEnergyUsed[s][p] : 0) : 0
                  output.data.dailyEnergyUsed[s][p] += L2_p_value + L3_p_value
                }
              }
            }

            // Work Weeks Weekends Energy Used SUM L1 L2 L3
            if (range == 'month') {
              output.data.workweeksWeekendsEnergyUsed = result[0].data.workweeksWeekendsEnergyUsed
              for (let s=0; s < result[0].data.workweeksWeekendsEnergyUsed.length; s++) {
                for (let p in result[0].data.workweeksWeekendsEnergyUsed[s]) {
                  if (p == "range") continue
                  const L2_p_value = result[1].data.workweeksWeekendsEnergyUsed.length ? (result[1].data.workweeksWeekendsEnergyUsed[s] ? result[1].data.workweeksWeekendsEnergyUsed[s][p] : 0) : 0
                  const L3_p_value = result[2].data.workweeksWeekendsEnergyUsed.length ? (result[2].data.workweeksWeekendsEnergyUsed[s] ? result[2].data.workweeksWeekendsEnergyUsed[s][p] : 0) : 0
                  output.data.workweeksWeekendsEnergyUsed[s][p] += L2_p_value + L3_p_value
                }
              }
            }
          }

          output.batteries = []
          if (batteries.length) {
            output.batteries = result.slice(-batteries.length).map(battery => {
              return { 
                summaryChart: battery.response.data.summaryChart.length ? battery.response.data.summaryChart : [],
                samples: battery.samples.length ? battery.samples : [],
                name: battery.b.name,
                device: battery.b,
                current_setpoint: battery.current_setpoint,
                last_sample: battery.last_sample
              }
            })
          }

          // FORECAST
          output.forecasts = []
          if (this.getters.user_isAdmin && forecast_result.length) {
            const forecast_devices = {
              forecast_consumption: forecast_result.filter(f => f.device.type == "forecast_consumption"),
              forecast_production: forecast_result.filter(f => f.device.type == "forecast_production")
            }

            for (let key in forecast_devices) {
              const datetimeSummaryChart = {}
              if (!forecast_devices[key].length) continue
              for (let device of forecast_devices[key]) {
                for (let sample of device.response.data.summaryChart) {
                  if (!datetimeSummaryChart.hasOwnProperty(sample.datetime)) {
                    datetimeSummaryChart[sample.datetime] = sample
                  } else {
                    for (let p in sample) {
                      if (["timestamp", "datetime", "L1", "L2", "L3", "producer", "device"].includes(p)) continue
                      datetimeSummaryChart[sample.datetime][p] += sample[p] ? sample[p] : 0
                    }
                  }
                }
              }
              output.forecasts.push({
                type: key,
                summaryChart: Object.values(datetimeSummaryChart).sort((a,b) => (new Date(a.datetime)).valueOf() - (new Date(b.datetime)).valueOf())
              })
            }
          }
          // END FORECAST

          // SAMPLES
          //output.samples = samples_result

          output.samples = []
          if (samples) {
            const samples_devices = {
              consumption: samples_result.filter(f => f.device.type == "consumption"),
              grid: samples_result.filter(f => f.device.type == "grid"),
              battery: samples_result.filter(f => f.device.type == "battery")
            }

            const power_fields = ["P", "Q"]
            for (let key in samples_devices) {
              const datetimeSummaryChart = {}
              if (!samples_devices[key].length) continue
              for (let device of samples_devices[key]) {
                for (let sample of device.data) {
                  if (!datetimeSummaryChart.hasOwnProperty(sample.datetime)) {
                    datetimeSummaryChart[sample.datetime] = sample
                    
                    if (device.type == "battery") {
                      if (device.phases.length == 1 && samples_devices[key].length > 1) {
                        for (phase of device.phases) {
                          for (p in sample){
                            if (p == "datetime") datetimeSummaryChart[sample.datetime][p] = sample[p]
                            if (["timestamp", "datetime", "L1", "L2", "L3", "producer", "device"].includes(p)) continue
                            datetimeSummaryChart[sample.datetime][phase+"."+p] = sample[p]
                          }
                        }
                      }
                    }
                  /*  for (let field of power_fields) {
                      datetimeSummaryChart[sample.datetime][field] = 0
                    }
                    if (key == "battery") {
                      datetimeSummaryChart[sample.datetime]["L1.Q"] = sample.inverterReactivePowerAvg
                      datetimeSummaryChart[sample.datetime]["L1.P"] = sample.inverterActivePowerAvg
                    } */
                  } 
                  else {
                    for (let p in sample) {
                      if (["timestamp", "datetime", "L1", "L2", "L3", "producer", "device"].includes(p)) continue
                      
                      if (!datetimeSummaryChart[sample.datetime].hasOwnProperty(p)) {
                        if (device.phases.length == 1 && samples_devices[key].length > 1) {
                          for (phase of device.phases) {
                              datetimeSummaryChart[sample.datetime][phase+"."+p] = sample[p]
                          }
                        }
                        else datetimeSummaryChart[sample.datetime][p] = sample[p]
                      }
                    }
                  }
                  /* for (let phase of ["L1", "L2", "L3"]) {
                    for (let field of power_fields) {
                      datetimeSummaryChart[sample.datetime][field] += sample[`${phase}.${field}`] ? sample[`${phase}.${field}`] : 0
                    }
                  } */
                }
              }
              output.samples.push({
                type: key,
                data: Object.values(datetimeSummaryChart).sort((a,b) => (new Date(a.datetime)).valueOf() - (new Date(b.datetime)).valueOf())
              })
            }
          }

          //console.log(output.samples)
          
          if (!multi_request && !recursive) commit('store_data', [output]) 
          if (!recursive) commit('data_loading', false)
          return resolve(output)
        })
      })
    },
    request_multi_data({commit}, {range, producerId, groups, datetimes, total_group_id=null}){
      return new Promise((resolve, reject) => {
        commit('data_loading', true)
        let producer = null
        if (this.getters.user_isAdmin) producer = this.state.producers.find(p => p.id == producerId || p._id == producerId) 
        else producer = this.state.user 
        let promises = []
      
        if (total_group_id){
          //this.dispatch('request_data', {range, producerId, groupId: total_group_id, datetime: datetimes})
          this.dispatch('request_single_data', {range, producerId, groupId: total_group_id, datetime: datetimes, multi_request: true})
          .then(response => {
            commit('data_loading', true)
            commit('store_data_total_group', response.data) 
          })
        }

        // Check if we have array of groups to request
        if (Array.isArray(groups)){
          const datetime = datetimes
         
          groups.forEach(g => {
            if (g._id == "all") return
            if ((g.devicesIds.length == 0 || g.devicesIds.length > 1)) return
            let device = producer.devices.find(d => d.deviceId == g.devicesIds[0])
            promises.push(new Promise(async (resolve, reject) => { 
              //const data = await this.dispatch('request_data', { range, producerId, groupId: g._id, datetime }).then(response => response)
              const data = await this.dispatch('request_single_data', { range, producerId, groupId: g._id, datetime, multi_request: true }).then(response => response)
              commit('data_loading', true)
              const last_data = await axios.get(`/api/device/${device.deviceId}/samples/minute`, { params: { producerId } }).then(response => response.data)
              let current_data = {}
              if (last_data.length) {
                if (isRecent(last_data[last_data.length-1].timestamp, 5)) {
                  current_data = last_data[last_data.length-1]
                  current_data.consumption = current_data['measure_cons']
                  delete current_data['measure_cons']
                }
              }

              let output = {
                current_data,
                //data,
                data: data.data || {},
                group: g,
                device
              }

              if (device.ev) {
                const ev_events = await this.dispatch('requestEVevents', device.deviceId).then(response => response)
                output.events = ev_events
              }
              
              resolve(output)
            }))
          })
        }
        // Otherwise check if we have an array of datetimes to request
        else if (Array.isArray(datetimes)){
          const group_id = groups
          const group = producer.groups.find(g => g._id == group_id)

          if (group.devicesIds.length == 0) return
          let device = producer.devices.find(d => d.deviceId == group.devicesIds[0])
          datetimes.forEach(datetime => {
            promises.push(new Promise(async (resolve, reject) => {
              //const data = await this.dispatch('request_data', { range, producerId, groupId: group._id, datetime })
              const data = await this.dispatch('request_single_data', { range, producerId, groupId: group._id, datetime })
              //console.log(data)
              let output = {
                datetime,
                data: data.data,
                group,
                device
              }
              resolve(output)
            }))
          })
        }
        
        Promise.all(promises).then(data => {
          commit('store_data', data)
          commit('data_loading', false)
          resolve()
        })
      })
    },
    setBattControlMode({commit}, {deviceId, mode, precharge}){
      //console.log("Set control mode", deviceId, mode, precharge)
      return new Promise((resolve, reject) => {
        axios.post(`/api/producer/updateBatteryMode/${deviceId}?producerId=${this.state.selection.producerId}`, {mode, precharge}).then(response => {
            resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    requestBattLastStatus({commit}, deviceId){
      //console.log("Get Battery last status", deviceId)
      return new Promise((resolve, reject) => {
        axios.get(`/bess-manager/xolta/device/${deviceId}/last`).then(response => {
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    sendBattSetpoints({commit}, {deviceId, setpoints}){
      return new Promise((resolve, reject) => {
        //console.log("Send Battery setpoint", deviceId, setpoints)
        axios.post(`/bess-manager/xolta/device/${deviceId}/setpoints`, setpoints).then(response => {
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    requestEVevents({commit}, deviceId){
      return new Promise((resolve, reject) => {
        axios.get(`/api/ev/${deviceId}/last-event`).then(response => {
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    stopCharging({commit}, deviceId){
      return new Promise((resolve,reject) => {
        axios.post(`/api/ev/${deviceId}/stop`).then(() => {
          this.dispatch('requestEVevents', deviceId).then(response_ev => {
            resolve(response_ev)
          })
        }).catch(err => reject(err))
      })
    },
    setChargingType({commit}, { deviceId, bool }){
      return new Promise((resolve,reject) => {
        let query = { smart_charging: bool }
        axios.post(`/api/ev/${deviceId}/setChargingType`, null, { params: query }).then(() => {
          this.dispatch('requestEVevents', deviceId).then(response_ev => {
            resolve(response_ev)
          })
        }).catch(err => reject(err))
      })
    },
    scheduleCharging({commit}, {deviceId, start, end, charging_rate=null}){
      return new Promise((resolve,reject) => {
        let query = { start, end, charging_rate }
        axios.post(`/api/ev/${deviceId}/schedule`, null, { params: query }).then(() => {
          this.dispatch('requestEVevents', deviceId).then(response_ev => {
            resolve(response_ev)
          })
        }).catch(err => reject(err))
      })
    },
    request_data_samples({commit}, {range, producerId=null, deviceId, datetime}){
      commit('data_loading', true)
      let query = {}
      query.datetime = datetime
      if (producerId) query.producerId = producerId
      return new Promise((resolve, reject) => {
        axios.get(`${url}/api/device/${deviceId}/samples/${range}`, { params: query }).then(response => { 
          commit('store_data', response.data)
          commit('data_loading', false)
          resolve()
        }).catch(err => reject(err))
      })
    },
    getFirstTimestamp({commit}, query) {
      return new Promise((resolve, reject) => {
        axios.get(`${url}/api/firstTimestamp`, { params: query }).then(response => {
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    forgotPassword({commit}, email){
      return new Promise((resolve, reject) => {
        axios.post(`${url}/api/forgotPassword`, { email }).then(response => {
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    resetPassword({commit}, { password, password_confirmation, token}){
      return new Promise((resolve, reject) => {
        axios.post(`${url}/api/resetPassword/${token}`, { password, password_confirmation }).then(response => {
          resolve(response.data)
        }).catch(err => reject(err))
      })
    },
    clearData({commit}){
      return new Promise((resolve, reject) => {
        commit('clear_data')
        resolve()
      }).catch(err => {console.log(err); reject(err);})
    },
    setRange({commit}, range){
      return new Promise((resolve, reject) => {
        commit('set_range', range)
        resolve()
      }).catch(err => reject(err))
    },
    setProducerId({commit}, producerId){
      return new Promise((resolve, reject) => {
        commit('set_producerId', producerId)
        resolve()
      }).catch(err => reject(err))
    },
    setGroupId({commit}, groupId){
      return new Promise((resolve, reject) => {
        commit('set_groupId', groupId)
        resolve()
      }).catch(err => reject(err))
    }
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    data_loading: state => state.data_loading,
    user: state => state.user,
    username: state => state.user.username,
    lastname: state => state.user.lastname,
    user_isAdmin: state => state.user.isAdmin,
    user_isSuperAdmin: state => state.user.isSuperAdmin,
    user_location: state => state.user.local.name,
    user_groups: state => state.user.groups || [],
    user_roles: state => state.user.roles,
    user_total_group: state => state.user.groups.find(g => g.name == "Total") || {},
    user_total_group_id: state => {
      if (state.user.groups.length)
        return state.user.groups.find(g => g.name == "Total")._id || null
    },
    user_id: state => state.user._id || state.user.id,
    user_group: state => groupId => state.user.groups.find(g => g._id == groupId) || {},
    user_devices: state => state.user.devices || [],
    remote_user_id: state => producerId => {
      return state.producers.find(p => p.id == producerId || p._id == producerId).id
    },
    user_contract: state => {
      if (state.user.isAdmin) {
        if (state.producers.length)
          return state.producers.find(p => p.id == state.selection.producerId || p._id == state.selection.producerId).contract || {}
        return {}
      }
      else {
        return state.user.contract || {}
      }
    },
    remote_user_total_group: state => producerId => {
      const groups = state.producers.find(p => p.id == producerId || p._id == producerId).groups || []
      if (!groups.length) return {}
      return (state.producers.find(p => p.id == producerId || p._id == producerId)).groups.find(g => g.name == "Total")
    },
    remote_user_total_group_id: state => producerId => {
      const groups = state.producers.find(p => p.id == producerId || p._id == producerId).groups || []
      if (!groups.length) return null
      const total_group = groups.find(g => g.name == "Total") || {}
      return total_group._id || null
    },
    remote_user_groups: state => producerId => {
      return state.producers.find(p => p.id == producerId || p._id == producerId).groups || []
    },
    remote_user_group: state => (producerId, groupId) => {
      return (state.producers.find(p => p.id == producerId || p._id == producerId)).groups.find(g => g._id == groupId) || {}
    },
    remote_user_devices: state => producerId => state.producers.find(p => p.id == producerId || p._id == producerId).devices || [],
    remote_user_bess: state => {
      if (state.producers.length)
        return (state.producers.find(p => p._id == state.selection.producerId || p.id == state.selection.producerId)).groups.find(g => g.bess.length) || false
    },
    remote_user_forecast: state => {
      if (state.producers.length)
        return (state.producers.find(p => p._id == state.selection.producerId || p.id == state.selection.producerId)).groups.find(g => g.name == "Forecast" && g.devicesIds.length) || false
    },
    group_forecasts: (state, getters) => {
      if (!getters.user_isAdmin) return []
      const group = getters.remote_user_group(getters.selected_producerId, getters.selected_groupId);
      const producer = getters.producers.find(p => p._id == getters.selected_producerId || p.id == getters.selected_producerId)
      if ((Object.keys(group).length === 0 && group.constructor === Object) || !producer) return []
      //console.log(group)
      let forecasts = []
      group.devicesIds.forEach(deviceId => {
        const device = producer.devices.find(d => d.deviceId == deviceId)
        if (device && device.hasOwnProperty("type") && (device.type == "forecast_consumption" || device.type == "forecast_production")) 
          forecasts.push(device)
      })
      return forecasts
    },
    producers: state => {
      return state.producers || []
      //return state.producers.filter(p => p.username.indexOf('UPAC') !== -1  || p.username.indexOf('Tukxi') !== -1 || p.username.indexOf('EV') !== -1) || []
    },
    timezone: state => state.timezone,
    selected_range: state => state.selection.range,
    selected_producerId: state => state.selection.producerId, 
    selected_groupId: state => state.selection.groupId, 
    data: state => state.data || [{}],
    data_savings: state => {
      return { 
        Savings: state.data.length && state.data[0].data.summaryChart.length ? state.data[0].data.energyUsed.Savings : null,
        Savings_Euro: state.data.length && state.data[0].data.summaryChart.length ? state.data[0].data.energyUsed.Savings_Euro : null,
        Savings_CO2: state.data.length && state.data[0].data.summaryChart.length ? state.data[0].data.energyUsed.Savings_CO2 : null
      }
    },
    data_total_group: state => state.data_total_group || {},
    data_summaryChart: state => state.data.length ? state.data[0].data.summaryChart : [],
    data_consumption_comparison: state => {
      if (state.data.length == 2) return [state.data[0].data.summaryChart, state.data[1].data.summaryChart]
      else return [[], []]
    },
    data_energyUsed_comparison: state => {
      if(state.data.length == 2) return [state.data[0].data.energyUsed, state.data[1].data.energyUsed]
      else return [[], []]
    },
    data_consumption: state => {
      let data = { Batt_House: null, Grid_House: null, PV_House: null }
      data = state.data.map(d => {
        return {
          Batt_House: d.data && d.data.summaryChart.length ? d.data.energyUsed.Batt_House : null,
          Grid_House: d.data && d.data.summaryChart.length ? d.data.energyUsed.Grid_House : null,
          PV_House: d.data && d.data.summaryChart.length ? d.data.energyUsed.PV_House : null
        }
      })

      return data
    },
    data_wastings: state => {
      return {
        PV_Batt: state.data.length && state.data[0].data.summaryChart.length ? state.data[0].data.energyUsed.PV_Batt : null,
        PV_Grid: state.data.length && state.data[0].data.summaryChart.length ? state.data[0].data.energyUsed.PV_Grid : null,
        PV_House: state.data.length && state.data[0].data.summaryChart.length  ? state.data[0].data.energyUsed.PV_House : null
      }
    },
    data_dailyEnergyUsed: state => state.data.length ? state.data[0].data.dailyEnergyUsed : null,
    data_workweeksWeekendsEnergyUsed: state => state.data.length ? state.data[0].data.workweeksWeekendsEnergyUsed : null,
    datetime1: state => state.data.length ? state.data[0].datetime : null,
    datetime2: state => state.data.length >= 2 ? state.data[1].datetime : null,
    current_data: state => state.current_data || {},
    user_bess: state => state.user.groups.find(g => g.bess.length) || false,
    datetimes: state => {
      let datetimes = []
      if (state.data.length){
        datetimes = state.data.map(d => {
          if(d.data.data && d.data.data.summaryChart.length) return d.datetime
        })
      }
      return datetimes
    },
    ev_colors: state => state.ev_colors,
    ev_devices: state => {
      if (state.user.isAdmin) {
        return (state.producers.find(p => p.id == state.selection.producerId || p._id == state.selection.producerId).devices).filter(d => d.ev) || {}
      }
      else return state.user.devices.filter(d => d.ev) || {}
    },
    token: state => state.token || null
  }
})